import React from "react";
import type { FC, PropsWithChildren } from "react";
import { Button } from "../../components/Modal";
import CheckboxInput from "../../components/Modal/CheckBoxInput";
import DisplayBox from "../../components/Modal/DisplayBox";
import {
  useSendConfirmation,
  useSendConsentRecorded,
} from "../../hooks/patients";
import PatientStyle from "../../styles/Patient.module.css";
import { IaddPatientModalStates } from "./AddPatientModal";
import EnrollPatientStyle from "../../styles/EnrollPatient.module.css";
import { confirmReq } from "../../hooks/patients/index.type";
import { useDispatch, useSelector } from "react-redux";

import { loginSliceValue } from "../../redux/reducers/loginSlice";
import {
  clearRescivedMessage,
  onlineUsersSliceValue,
} from "../../redux/reducers/onlineUsers";
import { IOnlineUserResp } from "../../redux/reducers/onlineUsers/index.types";
import { toast } from "react-hot-toast";
import { Socket } from "socket.io-client";
export type sendConfrimationModalState = PropsWithChildren<{
  status: boolean;
}>;

type AddEditModalProps = PropsWithChildren<{
  loading?: boolean;
  onCloseModal?: () => void;
  handleAddEdit?: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
  addEditModalStates: IaddPatientModalStates;
  setAddEditModalStates: React.Dispatch<
    React.SetStateAction<IaddPatientModalStates>
  >;
  socket: Socket | null;
  isFormValid?: boolean;
  onConsentChange?: (isConsentChecked: boolean) => void;
}>;

const ConfirmationInfo: FC<AddEditModalProps> = (props) => {
  const [checked, setChecked] = React.useState<boolean>(false);
  const [isConsentSent, setIsConsentSent] = React.useState<boolean>(false);
  const { userDetails } = useSelector(loginSliceValue);
  const onlineUsers = useSelector(onlineUsersSliceValue);

  const dispatch = useDispatch();

  const socketId = onlineUsers?.users?.find(
    (user: IOnlineUserResp) => user.userId === userDetails?.data?.user?._id
  )?.socketId;

  const { sendingConsent, sentConsent } = useSendConfirmation();
  const { sendingConsentRecorded, sendConsentRecorded } =
    useSendConsentRecorded();

  const handleConsentRecorded = async (isChecked: boolean) => {
    setChecked(isChecked);

    if (props.onConsentChange) {
      props.onConsentChange(isChecked);
    }

    if (isChecked) {
      const formattedPhone = props.addEditModalStates.phone.value.replace(
        /\D/g,
        ""
      );
      const clinicId = props.addEditModalStates.associatedClinic.value;

      const consentReceived =
        onlineUsers?.receivedMessage &&
        onlineUsers?.messageContent?.Body?.toLowerCase() === "yes";

      const formData = {
        phone: formattedPhone,
        consentMessageReceivedStatus: consentReceived ? "yes" : "no",
        associatedClinic: clinicId,
        status: "checked",
      };

      await sendConsentRecorded(formData);
    }
  };

  async function handleSentConfirmation() {
    if (!socketId) {
      toast.error("Socket connection not available");
      return;
    }

    const formattedPhone = props.addEditModalStates.phone.value.replace(
      /\D/g,
      ""
    );

    const formData: confirmReq = {
      phone: formattedPhone,
      socketId: socketId,
    };

    const data = await sentConsent(formData);

    if (data?.status === "success") {
      setIsConsentSent(true);
      props.socket?.emit("consent-form-reply", {
        phone: formattedPhone,
        socketId: socketId,
        timestamp: new Date().toISOString(),
        type: "consent-form-sent",
        messageId: (data as any)?.data?.messageId || null,
      });
    }
  }

  // const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();
  //   dispatch({ type: clearRescivedMessage });
  //   if (props.handleAddEdit) {
  //     try {
  //       await props.handleAddEdit(event);
  //     } catch (error) {
  //       console.error("Enrollment error:", error);
  //       toast.error("An error occurred during enrollment. Please try again.");
  //     }
  //     }
  //   }
  // };

  return (
    <>
      <div
        className={EnrollPatientStyle.confirmationSection}
        data-testid="confirmation-modal"
      >
        <div className={EnrollPatientStyle.confirmatiobButtonWrapper}>
          <Button
            label={isConsentSent ? "Consent Sent" : "Send Consent Message"}
            span={false}
            icon="icon-confirm-message"
            customClass={`${EnrollPatientStyle.consentButton} ${
              isConsentSent || sendingConsent || !props.isFormValid
                ? PatientStyle.inactive_btn
                : ""
            }`}
            onClick={handleSentConfirmation}
            disabled={isConsentSent || sendingConsent || !props.isFormValid}
          />
          {onlineUsers?.receivedMessage &&
            onlineUsers?.messageContent?.Body?.toLowerCase() === "yes" && (
              <div
                className={PatientStyle.message_box_wrapper}
                style={{ marginLeft: "auto" }}
              >
                <DisplayBox
                  text="Consent Received"
                  icon="right-tick"
                  className={PatientStyle.received_message_box}
                />
              </div>
            )}
        </div>
        <CheckboxInput
          label="Consent Recorded"
          checked={checked}
          onChange={(e) => handleConsentRecorded(e.target.checked)}
        />
      </div>
    </>
  );
};

export default ConfirmationInfo;
